export const VOLUNTEER_ORIENTATION_STATUS_ATTENDED = '507f1f77bcf86cd799489086';
export const VALID_PERIOD_1_YEAR_ID = '507f1f77bcf86cd799419086';
export const VALID_PERIOD_2_YEAR_ID = '507f1f77bcf86cd799419087';
export const VALID_PERIOD_3_YEAR_ID = '507f1f77bcf86cd799419088';
